exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=file][data-v-28efe956]{display:none}.dropzone-success[data-v-28efe956]{border:2px dashed #2d7cff}.dropzone[data-v-28efe956]{border:2px dashed #c5c5c5;padding:70px 60px 80px;background:0 0}.dropzone .icon[data-v-28efe956]{background-color:#e6e6e6;border-radius:50%;height:100px;width:100px;margin-bottom:15px;padding:20px;text-align:center;display:inline-block}.dropzone .icon span[data-v-28efe956]{font-size:60px;color:#646262}.drag-and-drop-label[data-v-28efe956]:hover{text-decoration:underline;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28efe956","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/SimpleDragAndDrop.vue
// module id = xVr/
// module chunks = 101